<template>
  <i-ant-design-product-outlined />
</template>
